module.exports = __webpack_public_path__ + "img/solo_logo_cliente.42a3e314.png";